module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Where do I begin? The seventh grade at St. Stephen’s on East 28th Street in 1941, I suppose, because that’s where and when I first met Jane, back before we grew up and she started disappearing and then reappearing in someplace like Tibet or Trucial Oman from where she’d send me picture postcards with tiny scrawled messages in different-colored inks such as, “Thinking of you sometimes in the morning” or “Angkor Wat really smells. Joey, don’t ever come here for a vacation,” but there’d be only a day between the postmarked dates and sometimes no difference at all between them, and then all of a sudden she’d reappear again looking years younger, which is nothing, I suppose, when compared to that time when supposedly she levitated six feet off the ground when she thought they were running out of Peter Paul Mounds candy bars at the refreshment counter of the old Superior movie house on 30th Street and Third Avenue back when there were el trains rumbling overhead and a nickel got you two or three feature films, plus a Buck Jones Western chapter, four cartoons, bingo and an onstage paddleball contest, when supposedly a theater usher approached her and told her, “Hey, come on, kid, get down, you can’t be doing that crazy stuff in here!” and right away she wobbled down to the seedy lobby carpet, gave the usher the arm and yelled, “That’s the same kind of crap they gave Tinkerbell!” but then I know you have no interest in any of these matters, so fine, let’s by all means move on and go back to the beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which comes at the end.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Medication time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It’s December 24, 2010, and I’m sitting by a window in a tenth-floor Bellevue Hospital recovery room staring down at a tugboat churning up a foaming white "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("V")]), _vm._v(" at its prow in the East River’s death-dark suicide waters and looking like it’s hugging itself against the cold. “Hi ya, kiddo!” The pudgy and diminutive Nurse Bloor breezily waddles into my room, a hypodermic syringe upraised in her pudgy little staph-infested fingers. She stops by my chair and I look down at her feet and I stare. I’ve never seen a nurse in stiletto heels. She glances over at something I sculpted a couple of days before and says, “Hey, now, what’s that?” and I tell her that it’s Father Perrault’s wooden leg from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lost Horizon")]), _vm._v(", but she doesn’t pursue it, nor does she react to my laptop computer: she has read "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Archy and Mehitabel")]), _vm._v(" and knows that sometimes even a rat can type.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay, a teensy little stick,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I yelp, “Ouch!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, come on, now, don’t tell me that hurt!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Well, it didn’t, but I want to puncture her starched-white pride and maddening air of self-assurance. She scowls, slaps a Band-Aid on the puncture and leaves. Sometimes growth of the soul needs pain, which is something I have always been on the spot to give.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The pneumatic door closes with a sigh. I turn my glance to my desk and the gift from Bloor that’s sitting on top of it, a foot-tall artificial Christmas tree with different-colored Band-Aids hanging from its branches. For a moment I stare at it dully, and then I shift my gaze to the dry and abandoned public pool down on the corner of First Avenue and 23rd where I almost drowned when Paulie Farragher and Jimmy Connelly kept shoving me back into the pool’s deep end every time I tried to climb up and out for air and I swore any number of choking, coughing blood oaths that if God let me live I would track them to Brazil or to China or the Yucatan, anyplace at all where I could offer them death without the comfort of the sacraments. Yes. I remember all of that. I do. I remember even though I’m eighty-two years old.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Again.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64879fc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780765326492_ch01.vue
// module id = 72
// module chunks = 0